import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  user: {
    borderBottom: 'none'
  },
  button: {
    padding: 0
  }
}));

export const useUserOverrideStyles = makeStyles(theme => ({
  name: {
    padding: theme.spacing(0, 1)
  }
}));
